import { InboxListItemContent } from 'Automations/components'
import { useManualTaskListItemContentToolkit } from 'Automations/nodeDefinitions/hooks/useManualTaskListItemContentToolkit'
import { TaskInput } from '../../types'
import { CustomerLogo } from '@sequencehq/core-components'
import { getInvoiceDueText } from 'Automations/helpers'
import { getLogoSrc } from 'Customer/index'
import { match } from 'ts-pattern'
import { prefetchEmailReviewPreview } from './prefetchEmailReviewPreview'

export const EmailReviewListItemContent = ({
  taskId,
  isSelected,
  hideUnreadIndicator,
  onClick
}: {
  taskId: string
  isSelected: boolean
  hideUnreadIndicator?: boolean
  onClick: (e: React.MouseEvent<HTMLDivElement, MouseEvent>) => void
}) => {
  const { manualTask, isUnread, statusIcon, preload } =
    useManualTaskListItemContentToolkit<TaskInput>({
      taskId
    })

  if (!manualTask?.input) {
    return <InboxListItemContent.Loading />
  }

  const customerId = manualTask.input.invoice.customerId
  const invoiceId = manualTask.input.invoice.id

  return (
    <InboxListItemContent
      isSelected={isSelected}
      isUnread={hideUnreadIndicator ? undefined : isUnread}
      onClick={onClick}
      onPreload={() =>
        Promise.all([
          preload(),
          prefetchEmailReviewPreview({ customerId, invoiceId })
        ])
      }
      title={getInvoiceDueText({
        invoiceNumber: manualTask.input.invoiceNumber,
        dueDate: manualTask.input.invoice?.dueDate
      })}
      description={match(manualTask.status)
        .with('COMPLETED', () => 'Payment reminder sent')
        .with('CANCELLED', () => 'Payment reminder cancelled')
        .otherwise(() => 'Payment reminder flagged for review')}
      createdAt={manualTask.createdAt}
      statusIcon={statusIcon}
      icon={
        <InboxListItemContent.TaskIcon isSelected={isSelected}>
          <CustomerLogo
            src={getLogoSrc(manualTask.input.customer)}
            size={24}
            fallbackSize={16}
          />
        </InboxListItemContent.TaskIcon>
      }
    />
  )
}
